import Vue from 'vue'
import VueRouter from 'vue-router'
import { path, pick } from 'ramda'
import { recordUsageData } from '@/utils/api/usage'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/offers',
    name: 'Offers',
    component: () => import('@/views/Offers.vue'),
    meta: {
      requiresAuth: true,
      hasHero: true,
    },
  },
  {
    path: '/offers/:offerId',
    name: 'Offer',
    component: () => import('@/views/Offer.vue'),
    meta: {
      forceHeader: true,
    },
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import('@/views/Orders.vue'),
    meta: {
      requiresAuth: true,
      hasHero: true,
    },
  },
  {
    path: '/orders/:orderId',
    name: 'Order',
    component: () => import('@/views/Order.vue'),
    meta: {
      requiresAuth: true,
      hasHero: true,
    },
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('@/views/Account.vue'),
    meta: {
      requiresAuth: true,
      hasHero: true,
    },
  },
  {
    path: '/basket',
    name: 'Basket',
    component: () => import('@/views/Basket.vue'),
    meta: {
      requiresAuth: true,
      hasHero: true,
      pageClasses: 'page--basket',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      pageClasses: 'page--login-background page--no-header',
      whiteFooter: true,
    },
  },
  {
    path: '/logout-confirmation',
    name: 'LogoutConfirmation',
    component: () => import('@/views/LogoutConfirmation.vue'),
    meta: {
      pageClasses: 'page--login-background page--no-header',
      whiteFooter: true,
    },
  },
  {
    path: '/resetpassword',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPassword.vue'),
    meta: {
      pageClasses: 'page--login-background page--no-header',
      whiteFooter: true,
    },
  },
  {
    path: '/basket/submitted',
    name: 'BasketSubmitted',
    component: () => import('@/views/BasketSubmitted.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/basket/import',
    name: 'ImportBasket',
    component: () => import('@/views/ImportBasket.vue'),
    meta: {
      requiresAuth: true,
      hasHero: true,
    },
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/views/PageNotFound.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  routes,
})

router.beforeEach((to, from, next) => {
  if (path(['name'], from) === 'LogoutConfirmation' && path(['name'], to) !== 'Login') {
    next(false)
  }

  // Log navigation as usage data.
  setTimeout(async () => {
    const initialisationPromise = path(['state', 'auth', 'initialisationPromise'], store)

    if (initialisationPromise) {
      await initialisationPromise
    }

    await recordUsageData(
      path(['state', 'auth', 'user', 'data', 'id'], store),
      'navigate',
      pick(['name', 'path', 'params'], to),
    )
  }, 1)

  next()
})

export default router
